import { MyleTableColumn } from "@/Common/Components/Tables/MyleTableColumn";
import { Person } from "@/Common/Models/Person/Person";
import { ClinicalWaitingListsSortOrderType, RedirectTo, SortDirection } from "@/Common/Models/UI/Enums";
import { TableColumnInfo } from "@/Common/Models/UI/Tables/ColumnConfigurationModel";
import { MyleTableTarget } from "@/Common/Models/UI/Tables/MyleTableTarget";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";
import { ClinicalWaitingListItem } from "@/Lists/Api/Dto/Response/ClinicalWaitingListItem";
import { ListsStore } from "@/Lists/Stores/ListsStore";

class ListsHandler extends BaseOperationHandler {
    constructor() {
        super();

        this.RegisterOperation(LocalOperations.Lists.Store_Mounted, this.StoreMoundted);
        this.RegisterOperation(LocalOperations.Lists.OnListTreeTitleClick, this.RefreshListTree);
        this.RegisterOperation(LocalOperations.Lists.List_Selected, this.SelectList);

        this.RegisterOperation(LocalOperations.Lists.AddNewList_ShowPopup, this.ShowAddNewListPopup);
        this.RegisterOperation(LocalOperations.Lists.AddNewList_Popup_Cancel, this.CancelAddNewListPopup);
        this.RegisterOperation(LocalOperations.Lists.AddNewList_Popup_Ok, this.OkAddNewListPopup);

        this.RegisterOperation(LocalOperations.Lists.OnPrintButtonClick, this.OnPrintButtonClickRequest);
        this.RegisterOperation(LocalOperations.Lists.OnRefreshButtonClick, this.OnRefreshButtonClick);
        this.RegisterOperation(LocalOperations.Lists.OnSettingsButtonClick, this.OnSettingsButtonClick);
        this.RegisterOperation(LocalOperations.Lists.SearchSettings_CancelClick, this.SearchSettingsCancelClick);
        this.RegisterOperation(LocalOperations.Lists.SearchSettings_OkClick, this.SearchSettingsOkClick);
        this.RegisterOperation(LocalOperations.Lists.SearchBoxTextChanged, this.SearchBoxTextChanged);
        this.RegisterOperation(LocalOperations.Lists.SearchSettings_ColumnOrderingPopup_Open, this.OpenSearchSettingsColumnOrderingPopup);
        this.RegisterOperation(LocalOperations.Lists.SearchSettings_ColumnOrderingPopup_Close, this.CloseSearchSettingsColumnOrderingPopup);
        this.RegisterOperation(LocalOperations.Lists.Search_CurrentPageChange, this.SearchCurrentPageChange);
        this.RegisterOperation(LocalOperations.Lists.SearchSettings_OnResultsPerPageChange, this.OnResultsPerPageChange);
        this.RegisterOperation(LocalOperations.Misc.MyleApp_Container_Click, this.OnContainerClick, false);

        this.RegisterOperation(LocalOperations.Lists.EditListName_ShowPopup, this.ShowEditListNamePopup);
        this.RegisterOperation(LocalOperations.Lists.EditListName_Popup_Cancel, this.CancelEditListNamePopup);
        this.RegisterOperation(LocalOperations.Lists.EditListName_Popup_Ok, this.OkEditListNamePopup);

        this.RegisterOperation(LocalOperations.Lists.DeleteListItem_ShowPopup, this.ShowDeleteListItemPopup);
        this.RegisterOperation(LocalOperations.Lists.DeleteListItem_Popup_Cancel, this.CancelDeleteListItemPopup);
        this.RegisterOperation(LocalOperations.Lists.DeleteListItem_Popup_Ok, this.OkDeleteListItemPopup);

        this.RegisterOperation(LocalOperations.Lists.DeleteList_ShowPopup, this.ShowDeleteListPopup);
        this.RegisterOperation(LocalOperations.Lists.DeleteList_Popup_Cancel, this.CancelDeleteListPopup);
        this.RegisterOperation(LocalOperations.Lists.DeleteList_Popup_Ok, this.OkDeleteListPopup);

        this.RegisterOperation(LocalOperations.Lists.OnAddAPatientClick, this.ShowSearchPatientPopup);
        this.RegisterOperation(LocalOperations.Lists.SelectPatientToAdd, this.SelectPatientToAdd);
        this.RegisterOperation(LocalOperations.Lists.CloseSelectedPatientPopup, this.CloseSelectedPatientPopup);
        this.RegisterOperation(LocalOperations.Lists.CloseSearchPatientPopup, this.CloseSearchPatientPopup);
        this.RegisterOperation(LocalOperations.Lists.SavePatientForList, this.SavePatientForList);

        this.RegisterOperation(LocalOperations.Lists.OnRowClick, this.OpenEditItemPopup);
        this.RegisterOperation(LocalOperations.Lists.EditItem_Popup_Ok, this.OkEditItemPopup);
        this.RegisterOperation(LocalOperations.Lists.EditItem_Popup_Cancel, this.CancelEditItemPopup);
        this.RegisterOperation(LocalOperations.Lists.EditItem_PriorityValueChanged, this.EditItemPriorityValueChanged);
        this.RegisterOperation(LocalOperations.Lists.EditItem_CommentsValueChanged, this.EditItemCommentsValueChanged);
        this.RegisterOperation(LocalOperations.Lists.EditItem_ValidatePriorityValue, this.EditItemValidatePriorityValue);
        this.RegisterOperation(LocalOperations.Lists.ToggleListsSearchSideBar, this.toggleListsSearchSideBar);

        this.RegisterOperation(LocalOperations.Misc.Table_ColumnSortClick, this.SetColumnSort);

        this.RegisterOperation(LocalOperations.Misc.RedirectToTab, this.OpenList);
        this.RegisterOperation(LocalOperations.Lists.SearchText_Change, this.UpdateSearchText);
    }

    // --------------------edit  && add item

    private filterPriority(priority: number): number {
        if (priority > 9)
            return 9;
        if (priority < 1)
            return 1;
        return priority;
    }

    private EditItemValidatePriorityValue(request: LocalEvent, store: ListsStore): void {
        var priotiryNewValue = request.Get<number>("priority");
        var priority = this.filterPriority(priotiryNewValue);
        store.ListCreateAndEditItemModel = store.ListCreateAndEditItemModel.set("Priority", priority.toString());
    }

    private OpenEditItemPopup(request: LocalEvent, store: ListsStore): void {
        var rowData = request.Get<ClinicalWaitingListItem>("rowData");

        store.ListCreateAndEditItemModel = store.ListCreateAndEditItemModel.set("SelectedItem", rowData);
        store.ListCreateAndEditItemModel = store.ListCreateAndEditItemModel.set("Comments", rowData.Comments);
        store.ListCreateAndEditItemModel = store.ListCreateAndEditItemModel.set("Priority", rowData.Priority.toString());
        store.ListCreateAndEditItemModel = store.ListCreateAndEditItemModel.set("OpenEditItemPopup", true);
        sessionStore.showGlobalOverlay(true);
    }

    private OkEditItemPopup(request: LocalEvent, store: ListsStore): void {
        var priotiryNewValue = parseInt(store.ListCreateAndEditItemModel.get("Priority"));
        var priority;

        if (priotiryNewValue <= 9 || priotiryNewValue >= 1) {
            priority = priotiryNewValue;
        }
        if (priotiryNewValue > 9) {
            priority = 9;
        }
        if (priotiryNewValue < 1) {
            priority = 1;
        }

        var comments = store.ListCreateAndEditItemModel.get("Comments");
        var itemId = store.ListCreateAndEditItemModel.get("SelectedItem").Id;

        store.ListsAction.editAnItemOfWaitingList(itemId, comments, priority);

        store.InitializeListCreateAndEditItemModel();
        store.ListCreateAndEditItemModel = store.ListCreateAndEditItemModel.set("OpenEditItemPopup", false);
        sessionStore.hideGlobalOverlay();
    }

    private CancelEditItemPopup(request: LocalEvent, store: ListsStore): void {
        store.InitializeListCreateAndEditItemModel();
        store.ListCreateAndEditItemModel = store.ListCreateAndEditItemModel.set("OpenEditItemPopup", false);
        sessionStore.hideGlobalOverlay();
    }

    private EditItemPriorityValueChanged(request: LocalEvent, store: ListsStore): void {
        var priority_str = request.Get<string>("priority");

        if (priority_str === "") {
            store.ListCreateAndEditItemModel = store.ListCreateAndEditItemModel.set("Priority", "");
        }
        else {
            var i = parseInt(priority_str);
            if (!isNaN(i)) {
                store.ListCreateAndEditItemModel = store.ListCreateAndEditItemModel.set("Priority", i.toString());
            }
        }
    }

    private EditItemCommentsValueChanged(request: LocalEvent, store: ListsStore): void {
        var comments = request.Get<string>("comments");

        store.ListCreateAndEditItemModel = store.ListCreateAndEditItemModel.set("Comments", comments);
    }

    private ShowSearchPatientPopup(request: LocalEvent, store: ListsStore): void {
        store.ListCreateAndEditItemModel = store.ListCreateAndEditItemModel.set("ListId", store.ListModel.get("ListId"));
        store.ListCreateAndEditItemModel = store.ListCreateAndEditItemModel.set("ShowSearchPatientPopup", true);
        sessionStore.showGlobalOverlay(true);
    }

    private SelectPatientToAdd(request: LocalEvent, store: ListsStore): void {
        var selectedPatient = request.Get<Person>("person");

        var listId = store.ListCreateAndEditItemModel.get("ListId");
        store.ListCreateAndEditItemModel = store.ListCreateAndEditItemModel.set("SelectedPatientForList", selectedPatient);

        store.ListsAction.checkIfSelectedPatientExists(listId, selectedPatient.ContactFacetId);

        store.ListCreateAndEditItemModel = store.ListCreateAndEditItemModel.set("ShowSearchPatientPopup", false);
        store.ListCreateAndEditItemModel = store.ListCreateAndEditItemModel.set("ShowSelectedPatientPopup", true);
    }

    private CloseSelectedPatientPopup(request: LocalEvent, store: ListsStore): void {
        store.InitializeListCreateAndEditItemModel();
        store.ListCreateAndEditItemModel = store.ListCreateAndEditItemModel.set("ShowSelectedPatientPopup", false);
        sessionStore.hideGlobalOverlay();
    }

    private CloseSearchPatientPopup(request: LocalEvent, store: ListsStore): void {
        store.ListCreateAndEditItemModel = store.ListCreateAndEditItemModel.set("ShowSearchPatientPopup", false);
        sessionStore.hideGlobalOverlay();
    }

    private SavePatientForList(request: LocalEvent, store: ListsStore): void {
        var priotiryNewValue = parseInt(store.ListCreateAndEditItemModel.get("Priority"));
        var priority = this.filterPriority(priotiryNewValue);

        var comments = store.ListCreateAndEditItemModel.get("Comments");

        var patientId = store.ListCreateAndEditItemModel.get("SelectedPatientForList").ContactFacetId;
        var listId = request.Get<string>("listId");

        store.ListsAction.addNewItemToWaitingList(listId, patientId, comments, priority);

        store.InitializeListCreateAndEditItemModel();
        store.ListCreateAndEditItemModel = store.ListCreateAndEditItemModel.set("ShowSelectedPatientPopup", false);
        sessionStore.hideGlobalOverlay();
    }

    // -------------------- delete list
    private ShowDeleteListPopup(request: LocalEvent, store: ListsStore): void {
        store.ListModel = store.ListModel.set("ShowDeleteListPopup", true);
        sessionStore.showGlobalOverlay(true);
    }

    private CancelDeleteListPopup(request: LocalEvent, store: ListsStore): void {
        store.ListModel = store.ListModel.set("ShowDeleteListPopup", false);
        sessionStore.hideGlobalOverlay();
    }

    private OkDeleteListPopup(request: LocalEvent, store: ListsStore): void {
        var listId = store.ListModel.get("ListId");
        store.ListsAction.deleteList(listId);

        store.ListModel = store.ListModel.set("ShowDeleteListPopup", false);
        sessionStore.hideGlobalOverlay();
    }

    // -------------------- list delete item
    private ShowDeleteListItemPopup(request: LocalEvent, store: ListsStore): void {
        var patientId = request.Get<string>("value");
        var item = store.ListModel.get("TableData").filter(s => s.Model.PatientId == patientId).first().Model;
        store.ListModel = store.ListModel.set("SelectedItem", item);

        store.ListCreateAndEditItemModel = store.ListCreateAndEditItemModel.set("ShowDeleteListItemPopup", true);
        sessionStore.showGlobalOverlay(true);
    }

    private CancelDeleteListItemPopup(request: LocalEvent, store: ListsStore): void {
        store.ListCreateAndEditItemModel = store.ListCreateAndEditItemModel.set("ShowDeleteListItemPopup", false);
        sessionStore.hideGlobalOverlay();
    }

    private OkDeleteListItemPopup(request: LocalEvent, store: ListsStore): void {
        var patientId = request.Get<string>("value");
        var listId = store.ListModel.get("ListId");
        store.ListsAction.removeItemFromList(listId, patientId);

        store.ListCreateAndEditItemModel = store.ListCreateAndEditItemModel.set("ShowDeleteListItemPopup", false);

        sessionStore.hideGlobalOverlay();
    }

    // ------------ Add new list
    private OkAddNewListPopup(request: LocalEvent, store: ListsStore): void {
        var newListName = request.Get<string>("value");

        store.ListsAction.addNewList(sessionStore.individualContactId, newListName);

        store.ListsTabModel = store.ListsTabModel.set("ShowAddNewListPopup", false);
        sessionStore.hideGlobalOverlay();
    }

    private ShowAddNewListPopup(request: LocalEvent, store: ListsStore): void {
        store.ListsTabModel = store.ListsTabModel.set("ShowAddNewListPopup", true);
        sessionStore.showGlobalOverlay(true);
    }

    // --------------------Settings

    private CloseSearchSettingsColumnOrderingPopup(request: LocalEvent, store: ListsStore): void {
        store.ListModel = store.ListModel.set("ColumnOrderingPopupOpen", false);
        store.ListModel = store.ListModel.set("ShowDisplaySettings", false);
        sessionStore.hideGlobalOverlay();
    }

    private OpenSearchSettingsColumnOrderingPopup(request: LocalEvent, store: ListsStore): void {
        store.ListModel = store.ListModel.set("ColumnOrderingPopupOpen", true);
        store.ListModel = store.ListModel.set("ShowDisplaySettings", false);
        sessionStore.showGlobalOverlay(true);
    }

    private SearchSettingsCancelClick(request: LocalEvent, store: ListsStore): void {
        store.ListModel = store.ListModel.set("ShowDisplaySettings", false);
    }

    private SearchSettingsOkClick(request: LocalEvent, store: ListsStore): void {
        store.ListModel = store.ListModel.set("ShowDisplaySettings", false);
        store.ListsAction.searchListItems(store.ListModel);
    }

    private SearchBoxTextChanged(request: LocalEvent, store: ListsStore): void {
        var GlobalSearchText = request.Get<string>("value");

        store.ListModel = store.ListModel.set("GlobalSearchText", GlobalSearchText);
        store.ListModel = store.ListModel.set("SelectedPageNumber", 1);
        store.ListsAction.searchListItems(store.ListModel);
    }

    private OnPrintButtonClickRequest(request: LocalEvent, store: ListsStore): void {
        store.ListsAction.onPrintButtonClickAction(
            store.ListModel,
            request.Get<TableColumnInfo[]>("columnsInfo"),
            request.Get<string>("phoneValidationRuleId")
        );
    }

    private OnRefreshButtonClick(request: LocalEvent, store: ListsStore): void {
        store.ListsAction.searchListItems(store.ListModel);
    }

    private CancelEditListNamePopup(request: LocalEvent, store: ListsStore): void {
        store.ListModel = store.ListModel.set("ShowEditListNamePopup", false);
        sessionStore.hideGlobalOverlay();
    }

    private OkEditListNamePopup(request: LocalEvent, store: ListsStore): void {
        var ListNewName = request.Get<string>("value");
        if (ListNewName !== "") {
            store.ListsAction.editListName(store.ListModel, ListNewName);
            sessionStore.hideGlobalOverlay();
        }
        else {
            store.ListModel = store.ListModel.set("ShowEditListNamePopup", false);
            sessionStore.hideGlobalOverlay();
        }
    }

    private ShowEditListNamePopup(request: LocalEvent, store: ListsStore): void {
        store.ListModel = store.ListModel.set("ShowEditListNamePopup", true);
        sessionStore.showGlobalOverlay(true);
    }

    private OnSettingsButtonClick(request: LocalEvent, store: ListsStore): void {
        var open = store.ListModel.get("ShowDisplaySettings");
        store.ListModel = store.ListModel.set("ShowDisplaySettings", !open);
    }

    private CancelAddNewListPopup(request: LocalEvent, store: ListsStore): void {
        store.ListsTabModel = store.ListsTabModel.set("ShowAddNewListPopup", false);
        sessionStore.hideGlobalOverlay();
    }

    private SelectList(request: LocalEvent, store: ListsStore): void {
        var listId = request.Get<string>("listId");
        var listName = request.Get<string>("listName");
        store.InitializeListModel();
        store.ListModel = store.ListModel.set("ListId", listId);
        store.ListModel = store.ListModel.set("ListName", listName);
        store.ListsTabModel = store.ListsTabModel.set("SelectedItemId", listId);
        store.ListsAction.searchListItems(store.ListModel);
    }

    private SearchCurrentPageChange(request: LocalEvent, store: ListsStore): void {
        var page = request.Get<number>("Page");
        store.ListModel = store.ListModel.set("SelectedPageNumber", page);
        store.ListsAction.searchListItems(store.ListModel);
    }

    private OnResultsPerPageChange(request: LocalEvent, store: ListsStore): void {
        store.ListModel = store.ListModel
            .set("SelectedPageNumber", 1)
            .set("SelectedPageSizeOption", request.Get<number>("value"));
    }

    private OnContainerClick(request: LocalEvent, store: ListsStore): void {
        if (store.ListModel.get("ShowDisplaySettings") === true) {
            store.ListModel = store.ListModel.set("ShowDisplaySettings", false);
            store.EmitChangeToListeners();
        }
        if (store.ListModel.get("ShowEditListNamePopup") === true) {
            store.ListModel = store.ListModel.set("ShowEditListNamePopup", false);
            sessionStore.hideGlobalOverlay();
            store.EmitChangeToListeners();
        }
        if (store.ListModel.get("ShowDeleteListPopup") === true) {
            store.ListModel = store.ListModel.set("ShowDeleteListPopup", false);
            sessionStore.hideGlobalOverlay();
            store.EmitChangeToListeners();
        }

        if (store.ListCreateAndEditItemModel.get("ShowSearchPatientPopup") === true) {
            store.ListCreateAndEditItemModel = store.ListCreateAndEditItemModel.set("ShowSearchPatientPopup", false);
            sessionStore.hideGlobalOverlay();
            store.EmitChangeToListeners();
        }
        if (store.ListCreateAndEditItemModel.get("ShowDeleteListItemPopup") === true) {
            store.ListCreateAndEditItemModel = store.ListCreateAndEditItemModel.set("ShowDeleteListItemPopup", false);
            sessionStore.hideGlobalOverlay();
            store.EmitChangeToListeners();
        }

        if (store.ListCreateAndEditItemModel.get("ShowSelectedPatientPopup") === true) {
            store.ListCreateAndEditItemModel = store.ListCreateAndEditItemModel.set("ShowSelectedPatientPopup", false);
            sessionStore.hideGlobalOverlay();
            store.EmitChangeToListeners();
        }
        if (store.ListCreateAndEditItemModel.get("OpenEditItemPopup") === true) {
            store.ListCreateAndEditItemModel = store.ListCreateAndEditItemModel.set("OpenEditItemPopup", false);
            sessionStore.hideGlobalOverlay();
            store.EmitChangeToListeners();
        }
    }

    // -------------------Sort table
    private SetColumnSort(request: LocalEvent, store: ListsStore): void {
        var tableTarget = request.Get<MyleTableTarget>("target");
        if (tableTarget === MyleTableTarget.Myle_Lists_Search_ColumnSortClick) {
            var columnOrderType = request.Get<ClinicalWaitingListsSortOrderType>("sortColumn");

            store.ListModel = store.ListModel.set("OrderByColumn", ClinicalWaitingListsSortOrderType[columnOrderType]);
            if (store.ListModel.get("OrderByDirection") === SortDirection[SortDirection.ASC])
                store.ListModel = store.ListModel.set("OrderByDirection", SortDirection[SortDirection.DESC]);
            else
                store.ListModel = store.ListModel.set("OrderByDirection", SortDirection[SortDirection.ASC]);

            var column = request.Get<MyleTableColumn>("columnObject");

            if (column) {
                if (column.columnOptions.IsSortActive) {
                    column.ToggleSortDirection();
                }
                column.columnOptions.IsSortActive = true;
            }
            store.ListsAction.searchListItems(store.ListModel);
        }
    }

    // ------------------Store Monted

    private StoreMoundted(request: LocalEvent, store: ListsStore): void {
        if (!store.defaultsLoaded) {
            store.ListsAction.loadLists(store.ListsTabModel);
        }
    }

    private RefreshListTree(request: LocalEvent, store: ListsStore): void {
        store.ListsAction.loadLists(store.ListsTabModel);
    }

    private OpenList(request: LocalEvent, store: ListsStore): void {
        var target = request.Get<RedirectTo>("target");
        if (target === RedirectTo.List) {
            store.ShowListTab();
            let listId = request.Get<string>("value");
            let listName = request.Get<string>("listName");
            store.InitializeListModel();
            store.ListModel = store.ListModel.set("ListId", listId);
            store.ListModel = store.ListModel.set("ListName", listName);
            store.ListsTabModel = store.ListsTabModel.set("SelectedItemId", listId);
            store.ListsAction.searchListItems(store.ListModel);

            sessionStore.hideGlobalOverlay();
        }
    }

    private UpdateSearchText(request: LocalEvent, store: ListsStore): void {
        const searchText = request.Get<string>("searchText");
        const pageSize = request.Get<number>("pageSize");
        store.ListsTabModel = store.ListsTabModel.set("SearchText", searchText);
        store.ListsTabModel = store.ListsTabModel.set("PageSize", pageSize);

        store.ListsAction.loadLists(store.ListsTabModel);
    }

    private toggleListsSearchSideBar(): void {
        const isMenuOpen = listsStore.ListsTabModel.get("SearchMenuOpen");
        listsStore.ListsTabModel = listsStore.ListsTabModel.set("SearchMenuOpen", !isMenuOpen);
    }
}

export { ListsHandler };
